export type Mode = "pause" | "play" | "live";
